import React, { useCallback } from 'react';

import Select from 'react-select-v3';
import { StyledFilter, reactSelectStyles } from './styled';
import { injectIntl } from 'react-intl';

const VehicleTypeFilter = ({ selectProps = {}, stylingProps = {}, value, onChange, intl }) => {
  const t = intl.messages.modules.Filters.vehicle_type;
  const vo = intl.messages.modules.Filters.vehicle_type.vehicle_options;
  const vehiclesOptions = [
    { label: vo.van_label, value: vo.van },
    { label: vo.box_van_label, value: vo.box_van },
    { label: vo.rigid_truck_label, value: vo.rigid_truck },
    { label: vo.trailer_label, value: vo.trailer },
  ];

  const handleChange = useCallback(
    (change) => {
      onChange(change);
    },
    [onChange]
  );

  return (
    <StyledFilter {...stylingProps}>
      <Select
        value={value}
        isMulti
        options={vehiclesOptions}
        onChange={handleChange}
        styles={{ ...reactSelectStyles, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        placeholder={t.placeholder}
        closeMenuOnSelect={false}
        menuPortalTarget={document.body}
        {...selectProps}
      />
    </StyledFilter>
  );
};

VehicleTypeFilter.filterName = 'VehicleTypeFilter';

export default injectIntl(VehicleTypeFilter);
